module.exports = __webpack_public_path__ + "static/media/7A0B9D58-CACE-48D9-A2BD-6AC2EF388491.2afeb621.JPG";